export default {
  id: 9,
  title: 'Target #9 - Tesseract',
  url: 'https://cssbattle.dev/play/9',
  colors: ['#222730', '#4CAAB3', '#393E46'],
  solution:
    '<p a><p b><p c><style>body{background:#222730}p{margin:0;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}p[a]{width:400;height:150;background:#4CAAB3}p[b]{width:150;height:150;transform:translate(-50%,-50%)rotate(45deg);background:#4CAAB3;border:50px solid #222730;border-radius:0.1px}p[c]{width:50;height:50;border-radius:50%;background:#393E46}</style>',
}
